<template>
  <canvas ref="canvasEl" class="qr-code"></canvas>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import QRCode from 'qrcode';

export default {
  name: 'QrCode',
  props: {
    value: { type: String, default: '' },
    size: { type: Number, default: 140 },
  },
  setup(props) {
    const canvasEl = ref(null);

    async function render() {
      if (!canvasEl.value || !props.value) return;
      try {
        await QRCode.toCanvas(canvasEl.value, props.value, {
          width: props.size,
          margin: 1,
        });
      } catch (error) {
        console.error('Erro ao gerar QR Code:', error);
      }
    }

    onMounted(render);
    watch(() => props.value, render);

    return { canvasEl };
  }
}
</script>

<style scoped>
.qr-code {
  display: block;
  width: 100%;
  max-width: 140px;
  height: auto;
}
</style>
